import React from 'react';
import styled from 'styled-components';
import WistiaVideo from 'components/Core/WistiaVideo';

const PartnersHeroSection = ({ backgroundImg, title, video, ...otherProps }) => {
  return (
    <SectionContainer backgroundImg={backgroundImg} {...otherProps}>
      <div className="section-partners-hero--wrapper">
        <div className="section-partners-hero--container">
          <h1 className="section-partners-hero--title">{title}</h1>
          <div className="section-partners-hero--video-content">
            <div className="section-partners-hero--video-container">
              <WistiaVideo dataPosition="Hero" url={video} size="Medium" />
            </div>
          </div>
        </div>
      </div>
    </SectionContainer>
  );
};

const SectionContainer = styled.div`
  background: white;
  padding-bottom: 500px;

  .section-partners-hero--wrapper {
    background: ${props => 'url(' + props.backgroundImg.file.url + ')'};
    height: 540px;
  }

  .section-partners-hero--container {
    margin: 0 auto;
    padding: 210px 28px 204px;

    .section-partners-hero--title {
      font-weight: 900;
      font-size: 61px;
      line-height: 110%;
      text-align: center;
      letter-spacing: -0.05em;
      color: var(--white-color);
      max-width: 784px;
      margin: 0 auto;
    }

    .section-partners-hero--video-content {
      padding: 0 54px 54px;
      position: relative;
      margin: 89px auto 0;
      max-width: 864px;
      overflow: hidden;

      .section-partners-hero--video-container {
        position: relative;

        &:before {
          content: '';
          position: absolute;
          background: #62bac7;
          width: 211px;
          height: 211px;
          bottom: -42px;
          right: -42px;
        }
      }
    }
  }

  @media (max-width: 768px) {
    padding-bottom: 280px;

    .section-partners-hero--wrapper {
      height: 294px;
    }

    .section-partners-hero--container {
      padding: 120px 28px;

      .section-partners-hero--title {
        font-size: 32px;
        letter-spacing: -0.03em;
        max-width: 590px;
      }

      .section-partners-hero--video-content {
        margin-top: 40px;
        padding: 0;

        .section-partners-hero--video-container {
          &:before,
          &:after {
            display: none;
          }
        }
      }
    }
  }

  @media (max-width: 576px) {
    padding-bottom: 210px;

    .section-partners-hero--wrapper {
      height: 278px;
    }

    .section-partners-hero--container {
      padding: 120px 28px;

      .section-partners-hero--video-content {
        .section-partners-hero--video-container {
          &:before {
            display: block;
            width: 100px;
            height: 13px;
            bottom: -13px;
            right: -13px;
          }

          &:after {
            display: block;
            width: 13px;
            height: 100px;
            bottom: -13px;
            right: -13px;
          }
        }
      }
    }
  }
`;

export default PartnersHeroSection;
